import {useMutation, useQueryClient} from '@tanstack/react-query'
import {updateGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useEditGoalV3 = (onSuccess?: () => void) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: updateGoal,
        onSuccess: (data, {goalId}) => {
            onSuccess?.()
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, goalId]}, oldData => {
                if (!oldData) return undefined
                return {...oldData, ...data}
            })
        }
    })
}
